<template>
  <div class="box">
    <div class="box-left">
      <img class="cover" :src="cover" />
    </div>
    <div class="box-right">
      <div class="live-title">
        <p>{{title}}</p>
        <span :class="getStatusStyle()">{{ getStatusStr() }}</span>
      </div>
      <div class="infolist">
        <div class="info-content-card">
          <div class="info-content-card-title">直播时长</div>
          <div class="info-content-card-value">{{runTimeHours}}小时{{runTimeMins}}分钟</div>
        </div>
        <div class="info-content-card">
          <div class="info-content-card-title">观看学员</div>
          <div class="info-content-card-value">{{studentCount}}人</div>
        </div>
        <div class="info-content-card">
          <div class="info-content-card-title">观看次数</div>
          <div class="info-content-card-value">{{viewCount}}次</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Live',
  props: {
    title: String,
    cover: String,
    status: String,
    runTimeHours: Number,
    runTimeMins: Number,
    studentCount: Number,
    viewCount: Number
  },
  methods: {
    getStatusStr () {
      if (this.status === 'UNLIVE') {
        return '未开播'
      } else if (this.status === 'LIVING') {
        return '直播中'
      } else if (this.status === 'ENDLIVE') {
        return '直播结束'
      } else {
        return '未开播'
      }
    },
    getStatusStyle () {
      if (this.status === 'UNLIVE') {
        return 'live-title-unlive'
      } else if (this.status === 'LIVING') {
        return 'live-title-living'
      } else if (this.status === 'ENDLIVE') {
        return 'live-title-lived'
      } else {
        return 'live-title-unlive'
      }
    }
  }
}
</script>

<style lang="less">
.box {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;

    .box-left {
      flex: 1;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;

      .cover{
        width: 85%;
        height: 88%;
        border-radius: 6px;
        object-fit: cover;
      }
    }

    .box-right {
      flex-shrink: 0;
      width: 100%;
      display: flex;
      flex-direction: column;
      padding: 0 3% 3%;
      box-sizing: border-box;

      .live-title {
        height: 26px;
        line-height: 26px;
        font-size: 14px;
        width: 100%;
        display: flex;
        align-items: center;

        p{
          margin: 0;
          max-width: 65%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 14px;
        }

        .live-title-unlive {
          color: #4d99fc;
          font-size: 12px;
          padding-left: 6px;
          font-style: oblique;
          font-weight: bold;
          flex-shrink: 0;
        }

        .live-title-living {
          color: #f46827;
          font-size: 12px;
          padding-left: 6px;
          font-style: oblique;
          font-weight: bold;
          flex-shrink: 0;
        }

        .live-title-lived {
          color: #40faee;
          font-size: 12px;
          padding-left: 6px;
          font-style: oblique;
          font-weight: bold;
          flex-shrink: 0;
        }
      }

      .infolist {
        width: 100%;
        display: flex;
        gap: 2%;
        margin-top: 6px;

        .info-content-card {
          background-color: rgba(35, 36, 134, 0.459);
          border-radius: 4px;
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 8px 2px;
          min-width: 0;
          box-sizing: border-box;

          .info-content-card-title {
            font-size: 11px;
            opacity: 0.75;
            margin-bottom: 4px;
            white-space: nowrap;
          }

          .info-content-card-value{
            color: #40FAEE;
            font-size: 13px;
            font-weight: 700;
            text-align: center;
            white-space: nowrap;
          }
        }
      }
    }
}
</style>
